import Entity from '../../components/entity';
import RecurringTransactionsTable from '../../components/tables/RecurringTransactionsTable';

const RecurringTransactionsPane = () => {
  const subtitle = 'This page is under development and the information displayed may not be accurate.';
  return (
    <Entity.Pane>
      <Entity.Header title="Recurring" subtitle={subtitle} />
      <Entity.Body primaryElement={<RecurringTransactionsTable />} />
    </Entity.Pane>
  );
};

export default RecurringTransactionsPane;
